import { createContext, useState } from 'react';
import api from 'services/api';

export const ServicoContext = createContext();

export const ServicoProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [servico, setServico] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getServico = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: servico?.filter,
        page: servico?.page,
        size: servico?.size,
        order: servico?.order,
        ...payload,
      });
      setServico((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <ServicoContext.Provider value={{ getLoading, servico, getServico }}>
      {children}
    </ServicoContext.Provider>
  );
};
